<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>

export default {
    name: 'App',
    components: {
    }
}
</script>

<style lang="less">
#app {
    height: 100%;
    width: 100%;
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
}
.van-toast--text {
  padding: 15px 20px !important;
}
.van-toast--text .van-toast__text{
  font-size: 26px !important;
}
@media only screen and (min-width: 600px){
  .video-c video {
    margin-top: 20px !important;
  }
  .video-c .close {
    width: 40px !important;
    height: 40px !important;
  }
  .noelectron-box {
    width: 200px !important;
    height: 150px !important;
    border-radius: 20px !important;
    .close{
      width: 30px !important;
      height: 30px !important;
      top: 10px !important;
      right: 10px !important;
    }
    .text{
      font-size: 16px !important;
    }
    .btn {
      bottom: 15px !important;
      height: 30px !important;
      width: 80px !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
    }
  }
  .data-loading-indicator:after{
    width: 50px !important;
    height: 50px !important;
  }
  .loading-cover .text{
    margin-top: 100px !important;
  }
  #app{
    width: 375.33px;
    .safetyCodeR {
      .header {
        height: 33px;
        font-size: 16px;
        margin-bottom: 33px;
        line-height: 33px;
      }
      .phone-input {
        height: calc(100% - 300px);
      }
      .title {
        margin-top: 40px;
        margin-bottom: 60px;
        font-size: 20px;
        letter-spacing: 2px;
      }
      .van-password-input .van-password-input__security{
        height: 50px !important;
      }
      .van-number-keyboard {
        width: 375.33px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        padding-bottom: 10px;
      }
      .van-number-keyboard__body{
        padding: 8px 0 0 8px !important;
      }
      .van-key__wrapper {
        padding: 0 8px 8px 0 !important;
      }
      .van-key--blue, .van-key--delete {
        font-size: 16px;
      }
      .van-key--large {
        right: 8px !important;
        bottom: 8px !important;
      }
      .van-key__delete-icon{
        width: 32px !important;
        height: 22px !important;
      }
      .van-number-keyboard__keys .van-key {
        height: 48px !important;
        font-size: 24px !important;
        border-radius: 10px !important;
      }
    }
  }
  #app .banner{
    height: 208.18px;
  }
  .popup{
    width: 375.33px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .qrcode-box {
    .qrcode-tip {
      font-size: 16px !important;
      height: 35px !important;
      line-height: 35px !important;
    }
    .qrcode-content {
      padding-top: 20px !important;
    }
    .qrcode-bg {
      width: 100% !important;
      height: 20px !important;
      border-radius: 5px !important;
    }
    .qrcode-text {
      padding-left: 55px !important;
      padding-right: 15px !important;
      font-size: 16px !important;
      margin-top: 10px !important;
    }
    .qrcode-text > div {

    }
    .qrcode-text .qrcode-img {
      margin-top: 30px !important;
    }
    .close {
      width: 30px !important;
      height: 30px !important;
      background-size: 20px 20px !important;
    }
    .qrcode-text::after {
      left: 15px !important;
      top: 0 !important;
      width: 20px !important;
      height: 20px !important;
      line-height: 20px !important;
      font-size: 14px !important;
    }
    .blue {
      line-height: 25px !important;
      margin: 0 10px !important;
      width: 45px !important;
      height: 25px !important;
    }
  }
  .qrcode-box1 img {
    width: 50% !important;
    margin-top: 10px !important;
    margin-left: calc(50% - 10px) !important;
  }
  .share-box {
    width: 310px !important;
    height: 230px !important;
    border-radius: 15px !important;
  }
  .share-box .share-btns{
    font-size: 16px !important;
    height: 40px !important;
  }
  .share-box .share-time {
    padding: 0 20px !important;
    margin-top: 20px !important;
  }
  .share-box .share-time span {
    min-width: 75px;
    width: auto !important;
  }
  .share-box .share-time select{
    height: 25px !important;
  }
  .share-box::after {
    top: 40px !important;
  }
  .share-box::before {
    height: 40px !important;
    line-height: 40px !important;
    font-size: 20px !important;
  }
  .Reporttxt .split{
    width: 98% !important;
    margin: 15px auto !important;
  }
  .Reporttxt {
    .main-btns {
      .blue, .orange {
        //width: 77% !important;
        height: 40px !important;
        border-radius: 20px !important;
        line-height: 40px !important;
        font-size: 16px !important;
        margin-top: 20px !important;
      }
    }
  }
  #app .all{
    padding-top: 192px;
    .content{
      border: 1px #d5d5d5 solid;
      padding: 15px !important;
      border-radius: 15px;
      font-size: 14px;
      min-height: 100%;
    }
    .jc-between .label{
      width: 60px !important;
    }
    .jc-between .value {
      margin-left: 10px !important;
      width: auto;
    }
    .pair .value {
      margin-left: 10px !important;
    }
    .row {
      margin-top: 15px;
    }
    .head-title {
      font-size: 20px;
    }
    .title{
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      margin-bottom: 5px;
      margin-top: 5px;
    }
    .btns{
      width: 280px;
      margin-top: 10px;
      height: 40px;
      .orange, .blue {
        margin-left: 5px;
        font-size: 14px;
        line-height: 25px;
        width: 70px;
        padding: 0 5px;
        height: 24px;
        border-radius: 12px;
      }
    }
    .history {
      padding: 20px 0;
      .blue {
        width: 77%;
        height: 40px;
        border-radius: 20px;
        line-height: 40px;
      }
    }
    .center-btns{
      margin-top: 10px;
      width: 100%;
      height: 100px;
      img{
        width: 50px;
        height: 50px;
      }
      .btn {
        height: 90px;
      }
      .split {
        width: 1px;
        height: 60%;
      }
    }
  }
}
</style>
